import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { VerificarPedido } from "./modules/VerificarPedido";

// La app no tiene router: la única "ruta" es el parámetro ?verificar=<token>
// que llevan los QR impresos en las órdenes de pedido. Se decide aquí, antes
// de montar App, para que quien escanea el QR no arranque toda la aplicación
// interna (sesión, carga de tablas, login) solo para ver un documento.
const token = new URLSearchParams(window.location.search).get("verificar");
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<StrictMode data-id="element-110" data-mp="2k20c0x8mn1ac">
    {token ? <VerificarPedido token={token} data-id="element-111" data-mp="2k2s4w0auakwx" /> : <App data-id="element-112" data-mp="2p0biqz3mkvoc" />}
  </StrictMode>);